// src/pages/About.jsx
import React from "react";
import MainLayout from "../components/Layouts/MainLayout";
import InnerBanner from "../components/PagesComponents/InnerBanner";
import { useLanguage } from "../contexts/LanguageContext"; // Import Language Context
import { translations } from "../i18n"; // Import Translations
import importImage from "../utils/images/importImage";

const OrderInfo = () => {
  const secImage3 = importImage("section-image3.jpg");
  const secImage4 = importImage("section-image4.jpg");
  const { language } = useLanguage(); // Get the current language
  const aboutData = translations[language]?.aboutData; // Fetch translations for "about"


  return (
    <MainLayout>
      <InnerBanner pageKey="orderInfo" />

<section className="py-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-4">
        <div className="sm-cn-wrap order-summary">
          <h6>Thank you. Your order has been received.</h6>
          <div className="order-box mt-3">
            <div className="od-smry">
              <p>Order Number:</p>
              <span>12827</span>
            </div>
            <div className="od-smry">
              <p>Date:</p>
              <span>September 6, 2024</span>
            </div>
            <div className="od-smry">
              <p>Email:</p>
              <span>customer@example.com</span>
            </div>
            <div className="od-smry">
              <p>Total:</p>
              <span><b className="text-black">$</b></span>
            </div>
            <div className="od-smry">
              <p>Payment Method:</p>
              <span>Direct Bank Transfer</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-8">
        <div className="big-cn-wrap order-details">
          <h5>Order Details</h5>
          <div className="od-dtl">
            <p>quantity</p>
            <span>x1</span>
            <p>$100.00</p>
          </div>
          <div className="od-dtl">
            <p>Subtotal:</p>
            <span></span>
            <p>$...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
      
    </MainLayout>
  );
};

export default OrderInfo;